/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DayOfWeek } from './DayOfWeek';
import {
    DayOfWeekFromJSON,
    DayOfWeekFromJSONTyped,
    DayOfWeekToJSON,
    DayOfWeekToJSONTyped,
} from './DayOfWeek';

/**
 * 
 * @export
 * @interface ReachabilityWindowResponse
 */
export interface ReachabilityWindowResponse {
    /**
     * 
     * @type {DayOfWeek}
     * @memberof ReachabilityWindowResponse
     */
    weekday: DayOfWeek;
    /**
     * 
     * @type {string}
     * @memberof ReachabilityWindowResponse
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof ReachabilityWindowResponse
     */
    to: string;
}



/**
 * Check if a given object implements the ReachabilityWindowResponse interface.
 */
export function instanceOfReachabilityWindowResponse(value: object): value is ReachabilityWindowResponse {
    if (!('weekday' in value) || value['weekday'] === undefined) return false;
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('to' in value) || value['to'] === undefined) return false;
    return true;
}

export function ReachabilityWindowResponseFromJSON(json: any): ReachabilityWindowResponse {
    return ReachabilityWindowResponseFromJSONTyped(json, false);
}

export function ReachabilityWindowResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReachabilityWindowResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'weekday': DayOfWeekFromJSON(json['weekday']),
        'from': json['from'],
        'to': json['to'],
    };
}

export function ReachabilityWindowResponseToJSON(json: any): ReachabilityWindowResponse {
    return ReachabilityWindowResponseToJSONTyped(json, false);
}

export function ReachabilityWindowResponseToJSONTyped(value?: ReachabilityWindowResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'weekday': DayOfWeekToJSON(value['weekday']),
        'from': value['from'],
        'to': value['to'],
    };
}

